/** Activate once near the viewport; scrolling back must not restart loading. */
export function observeLearningAudio(target: Element, ready: () => void) {
  if (typeof IntersectionObserver === 'undefined') { ready(); return () => undefined }
  let activated = false
  const observer = new IntersectionObserver(entries => {
    if (activated || !entries.some(entry => entry.isIntersecting)) return
    activated = true
    observer.disconnect()
    ready()
  }, { rootMargin: '160px 0px', threshold: 0 })
  observer.observe(target)
  return () => observer.disconnect()
}
